// Admin API client — /admin/dashboard/* (mirrors the API's dashboard aggregate).

import type {
  AdminAscCredentialErrorsResponse,
  AdminDashboardStats,
  AdminKpiDashboardResponse,
} from '@a7y/types';
import { client } from './transport';

export const dashboardApi = {
  // Dashboard
  getDashboardStats: () => client.get<AdminDashboardStats>('/dashboard/stats'),
  // Dashboard KPIs (nightly snapshots)
  getDashboardKpis: () => client.get<AdminKpiDashboardResponse>('/dashboard/kpis'),
  // Dashboard live data (support threads, etc.)
  getDashboardLive: () => client.get<{ openSupportThreads: number }>('/dashboard/live'),
  // A7Y-878: projects whose ASC credential is currently rejected by Apple
  getAscCredentialErrors: () =>
    client.get<AdminAscCredentialErrorsResponse>('/dashboard/asc-credential-errors'),
};
